import type { PropsWithChildren, ReactNode } from "react";

import { HStack } from "../Stack/HStack.tsx";
import style from "./CardContent.module.css";

interface CardSectionProps {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode[];
}

const CardSection = (props: PropsWithChildren<CardSectionProps>) => {
  return (
    <>
      {props.title != undefined && (
        <div className={style.section_title} data-testid="card-section">
          <HStack style={{ justifyContent: "space-between" }}>
            {props.title}
            <HStack>{props.actions}</HStack>
          </HStack>

          {props.description != undefined && <div className={style.section_description}>{props.description}</div>}
        </div>
      )}
      {props.children}
    </>
  );
};

export { CardSection };
